import { render, staticRenderFns } from "./CreateSageCustomerPopUp.vue?vue&type=template&id=4f0dcf42&scoped=true&"
import script from "./CreateSageCustomerPopUp.vue?vue&type=script&lang=js&"
export * from "./CreateSageCustomerPopUp.vue?vue&type=script&lang=js&"
import style0 from "./CreateSageCustomerPopUp.vue?vue&type=style&index=0&id=4f0dcf42&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f0dcf42",
  null
  
)

export default component.exports